<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="title-big">
            <h1>Hello</h1>
        </div>
        <div class="title-text">
            欢迎来到爱驿站 {{ stationName }}
        </div>
        <div class="title-text">
            您前面还有 <span style="color: #FE405F"> {{waiting}} </span> 位顾客在等待
        </div>


        <div class="title-num">
            {{callCount}}
        </div>
        <div class="title-tips">
            您的排队编号
        </div>

        <div class="cancel-tips">
            <van-checkbox v-model="noTips" icon-size="13px">取消叫号后，20分钟后此号码可以再次叫号</van-checkbox>
        </div>

        <div class="reload-btn" @click="onCancel">
            取消叫号
        </div>

        <div class="footer">
            <p>江苏爱驿站信息科技有限公司</p>
            <p>Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
        </div>


    </div>
</template>

<script>

import {showFailToast, showSuccessToast} from "vant";
import ayzAjax from "@/plugins/axios";

export default {
    name: "ReloadView",
    data: function () {
        return {
            stationName:'xiaoxiandian',
            callCount:66,
            waiting:55,
            noTips: false,
            ticket: null,
            station: null,
        }
    },
    created() {
        this.onTicket();
    },
    methods: {
        onCancel(){
            if (this.noTips === false) {
                showFailToast('请勾选提示语, 取消叫号');
                return false;
            }
            //aborted
            let fromData = {};
            fromData.ticket_id = this.ticket.ticket_id;
            fromData.token = this.ticket.token;
            ayzAjax.post('/call/aborted',fromData).then((response) => {
                if(response.data.code !== 200){
                    return showFailToast(response.data.msg)
                }
                // localStorage.setItem('callTicket', JSON.stringify(response.data.data));
                // this.$router.push({ path: '/call/cancel'});
                this.$router.push({ path: '/call/reload'});
            })
            showSuccessToast('已取消叫号')
            return false;
        },
        onTicket(){
            this.station = JSON.parse(localStorage.getItem('station'));
            this.stationName = this.station.title;
            this.ticket = JSON.parse(localStorage.getItem('callTicket'));

            let fromData = {}
            fromData.ticket_id = this.ticket.ticket_id;
            fromData.token = this.ticket.token;
            ayzAjax.post('/call/my_queueing_info',fromData).then((response) => {
                if(response.data.code !== 200){
                    return showFailToast(response.data.msg)
                }
                localStorage.setItem('callTicket', JSON.stringify(response.data.data));
                this.ticket = JSON.parse(localStorage.getItem('callTicket'));
                this.waiting = this.ticket.wait_count;
                this.callCount = this.ticket.ticket_number;
                console.log(this.ticket.status);
                if(this.ticket.status > 1){
                    this.$router.push({ path: '/call/reload'});
                }
            })
        }

    }
}
</script>

<style lang="scss" scoped>

.reload-view{
    //width: 100%;
    background-color: #FFFFFF;
    text-align: left;
    padding: 40px 30px 0 30px;
    .title-big{
        margin: 10px 10px 40px 10px;
    }
    .title-text{
        margin: 20px 10px 0 10px;
        font-weight: 550;
        font-size: 15px;
    }
    .title-num{
        margin-top: 100px;
        color: #222222;
        //margin-bottom: 100px;
        text-align: center;
        font-weight: bold;
        font-size: 150px;
    }
    .title-tips{
        text-align: center;
        color: #999999;
    }
    .cancel-tips{
        //margin-left: 5%;
        margin-top: 80px;
        text-align: center;
        color: #707070;
        font-size: 13px;
    }
    .reload-btn{
        margin-top: 20px;
        height: 60px;
        line-height: 60px;
        background-color: #FE405F;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
    .footer{
        margin-top: 80px;
        padding-bottom: 20px;
        text-align: center;
        color: #A5A5A5;
        font-weight: 300;
        font-size: 13px;
    }
}
</style>
